import { gql } from "@apollo/client";

export const SELLER_PRODUCTS_QUERY = gql`
  query SellerProducts($page: Int!, $pageSize: Int!, $filter: ProductFilterInputt) {
    sellerProducts(page: $page, page_size: $pageSize, filter: $filter) {
      products {
        entityid
        name
        sku
        prices
        status
        product_status
        is_approved
        visibility
        weight
        sellercategories {
          id
          name
        }
        image1 {
          url
          label
        }
        type_id
        variants_count
        longueur25
        dimensions_de_l_outil_largeur1
        dimensions_de_l_outil_hauteur1
        percent_commission_for_product
        commission_for_product
        specialprice
        start_date
        end_date
        mode_expedition
        stock_data {
          qty
          is_in_stock
        }
        marque
        deactivation_reason {
                description
                reason
        }
        total_sold
      }
      pagination {
        total_count
        current_page
        total_pages
      }
      product_status {
        approved_count
        disapproved_count
        rejected_count
      }
    }
  }
`;
